export const selectHeaderNameByCode = (state, code) => {
    const items = state.header?.headers?.headers;
    const match = items.find((item) => item.code === code);
    return match ? match?.name : null;
}

export const selectHeaderContentByCode = (state, code) => {
    const items = state.header?.headers?.headers;
    const match = items.find((item) => item.code === code);
    return match ? match?.translations : null;
}

export const selectHeaderContentByCodeAndLang = (state, code, lang) => {
    const translations = selectHeaderContentByCode(state,code);
    const match = translations.find((item) => item.languageCode === lang);
    return match ? match?.content: null;
}

export const selectFooterNameByCode = (state, code) => {
    const items = state.footer?.footers?.footers;
    const match = items.find((item) => item.code === code);
    return match ? match?.name : null;
}

export const selectFooterContentByCode = (state, code) => {
    const items = state.footer?.footers?.footers;
    const match = items.find((item) => item.code === code);
    return match ? match?.translations : null;
}

export const selectFooterContentByCodeAndLang = (state, code, lang) => {
    const translations = selectFooterContentByCode(state,code);
    const match = translations.find((item) => item.languageCode === lang);
    return match ? match?.content: null;
}